import {Button} from "@mui/material";

const ButtonExit = ({onClick,width=117, text,sx}) => {
    return <Button
        onClick={onClick}
        sx={{
            width: width,
            height: 56,
            textTransform: 'none',
            fontSize: '16px',
            color: (theme) => theme.palette.text.main,
            "&:hover": {
                backgroundColor: 'transparent',
            },
            ...sx,
        }}>
        {text}
    </Button>
}
export default ButtonExit